import {inject, injectable, IServiceConfig, RestService} from "@athena-portal/core";
import {IPromotionPortalService} from "../IPromotionPortalService";
import {Types} from "../../Types";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {AjaxResponse} from "rxjs/ajax";
import {VehicleDetails} from "../../model/VehicleDetails";
import { FreeInsuranceRequest } from "src/model/FreeInsuranceRequest";
import { InsuranceContributionRequest } from "src/model/InsuranceContributionRequest";

@injectable()
export class PromotionPortalServiceImpl extends RestService implements IPromotionPortalService {

    private configuration: IServiceConfig;

    constructor(@inject(Types.PromotionPortalServiceConfig) configuration: IServiceConfig) {
        super();
        this.configuration = configuration;
    }

    public getAvailablePromotionsByType(promotionType: number, saleDate: string): Observable<any> {
        const searchParams: URLSearchParams = new URLSearchParams();
        searchParams.append("saleDate", saleDate);

        return this.doRequest<any>(
            `/promotions/availablePromotions/${promotionType}?${searchParams.toString()}`,
            "GET",
            undefined,
            "Get promotion error.",
            undefined,
            true
        )
    }

    public saveFreeInsuranceEligibility(request: FreeInsuranceRequest): Observable<any> {
        return this.doRequest<any>(
            `/promotions/saveFreeInsurance`,
            "POST",
            request,
            "Failed to register promotion eligibility.",
            undefined,
            true
        );
    }

    public saveInsuranceContributionEligibility(request: InsuranceContributionRequest): Observable<void> {
        return this.doRequest<any>(
            `/promotions/saveInsuranceContribution`,
            "POST",
            request,
            "Failed to register promotion eligibility.",
            undefined,
            true
        );
    }

    public getVehicleDetails(vrn: any): Observable<VehicleDetails> {
        return this.doRequest<any>(
            `/promotions/getVehicleDetails/${vrn}`,
            "GET",
            undefined,
            "Get vehicle details error.",
            undefined,
            true
        )
    }

    public checkRetailerByOutletCode(outletCode: any): Observable<any> {
        return this.doRequest<any>(
            `/promotions/checkRetailer/${outletCode}`,
            "GET",
            undefined,
            "Check retailer code error.",
            undefined,
            true
        )
    }

    // @ts-ignore
    private doRequest<T> (urlAppend: string, method?: string, body?: any, errorMessage?: string, onErrorReturn?: T, showErrorMessage: boolean): Observable<T>{
        return super.getProtectedResource({
            body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}${urlAppend}`,
        }, this.configuration.customQueryStringParameters).pipe(
            map((response: AjaxResponse): T => {
                    return response.response;
                }
            )
        );
    }
}
